import { ExtendedObservation } from '@seen/core/models/observation'
import { useCallback } from 'react'
import { useDeleteMutation } from '#src/hooks/useDeleteMutation.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

// A preliminary record was never part of a signed note, so it is deleted
// outright; anything already final stays in history as entered-in-error.
export function useRemoveObservationRecord(): (
  observation: ExtendedObservation
) => Promise<void> {
  const { mutateAsync: patch } = usePatchMutation<ExtendedObservation>()
  const { mutateAsync: remove } = useDeleteMutation(ExtendedObservation)
  return useCallback(
    async (observation: ExtendedObservation) => {
      if (observation.isPreliminary) {
        await remove(observation)
        return
      }
      await patch({
        instance: observation,
        mutateFn: (o) => {
          o.markAsEnteredInError()
        },
      })
    },
    [patch, remove]
  )
}
